/* global $ */

const COLUMN_TOGGLE_CLASS = '.js-list-view-columns-filter';

const Columns = {

  /**
   * Initialize columns functionality
   * @param {HTMLElement} listViewNode
   * @return {void}
   */
  initialize(listViewNode) {
    this.listView = listViewNode;
    this.$listView = $(this.listView);
    this.$columnsFilter = this.$listView.find(COLUMN_TOGGLE_CLASS);

    this.createListeners();

    const columns = this.getColumns();
    this.outputColumnsToFilter(columns);
  },

  /**
   * Create event listeners for the columns toggle functionality
   * @return {void}
   */
  createListeners() {
    this.$columnsFilter.on('change', 'input[type="checkbox"]', () => {
      const selectedColumns = this.getSelectedColumns();
      this.displayAvailableColumns(selectedColumns);
    });
  },

  /**
   * Get available columns by retrieving the table headers
   * @return {Array}
   */
  getColumns() {
    const $th = this.$listView.find('th[data-column]');

    const columns = $th.toArray().map(th => ({
      id: $(th).data('column'),
      name: $(th).text().trim(),
      visible: $(th).is(':visible'),
    }));

    return columns;
  },

  /**
   * Output the columns to check boxes inside the filter
   * @param {Array} columns
   * @return {void}
   */
  outputColumnsToFilter(columns) {
    // Create a HTML string for checkboxes
    const createCheckboxes = columns.reduce((acc, obj) => (`
      ${acc}
      <div class="form-check">
        <input class="form-check-input" type="checkbox" name="columns" id="${obj.id}" value="${obj.id}" ${obj.visible ? 'checked' : ''}>
        <label class="form-check-label" for="${obj.id}">${obj.name}</label>
      </div>
    `), '');

    // Output checkboxes
    this.$columnsFilter.html(createCheckboxes);
  },

  /**
   * Get a list of all checkboxes and if the're checked
   * @return {Array}
   */
  getSelectedColumns() {
    const $inputElements = this.$columnsFilter.find('input');

    return $inputElements.toArray().map(el => ({
      checked: el.checked,
      value: el.value,
    }));
  },

  /**
   * Toggle the available columns
   * @param {Array} columns
   * @return {void}
   */
  displayAvailableColumns(columns) {
    columns.forEach((obj) => {
      const $col = $(`[data-column="${obj.value}"]`);

      $col[!obj.checked ? 'attr' : 'removeAttr']('data-hide', true);
    });
  },
};

export default Columns;
